const wellnesscontent = {
  header: "Massage Therapy",
  subheading: "Recovery That Keeps You Moving",
  summary:
    "Built for active adults, our massage therapy sessions help improve mobility, accelerate recovery, and support long-term performance. Whether you're training regularly or managing recurring tightness, treatment is tailored to help you stay consistent and active.",
  listOne: [
    "Address aches before they become injuries",
    "Reduce muscle tension and restrictions",
    "Improve mobility and performance",
    "Support faster recovery",
    "Targeted treatment",
  ],
};

export default wellnesscontent;
